<template>
  <v-main>
    <v-row class="py-2 pl-2 pr-0">
      <v-col class="px-2 py-0" cols="6">
        <v-radio-group 
          v-model="formData.tipo_consulta"
          row
          small
          @change="clearFilter()"
          v-show="envio_digitacao_robo && (exibirNivelGuia || formData.tipo_consulta!='lotes')"
        >
          <v-radio label="Lotes" value="lotes"></v-radio>
          <v-radio label="Guias" value="guias"></v-radio>
        </v-radio-group>
        
      </v-col>
    </v-row>
    <!-- <v-divider class="pb-2 mx-0 my-0" v-show="envio_digitacao_robo && (exibirNivelGuia || formData.tipo_consulta!='lotes')"></v-divider><br /> -->
    <v-form ref="edicaoRecursosFilterForm">
      <v-row class="pt-4 pl-2 pr-0">
        <v-col class="px-2 py-0" cols="1">
          <label>Status</label>
          <v-select
            v-model="formData.status_envio"
            :items="comboEstados"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          >
          <template v-slot:item="data">
              <template v-if="(typeof data.item !=='object')">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
               <v-list-item-content>
                  <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar size="14" :color="data.item.color" v-if="data.item.color">
                </v-list-item-avatar>
              </template>
            </template>
          </v-select>
        </v-col>
        <!-- <v-col class="px-2 py-0" cols="1">
          <label>Id. operadora</label> 
          <v-select
            v-model="formData.identificador_prestador"
            :items="identOperadoraList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col> -->
        <v-col class="px-2 py-0" :cols="formData.tipo_consulta=='lotes'?1:2">
          <label>Nº do Lote</label>
          <v-autocomplete
            v-model="formData.numero_lote"
            :items="numLotesList"
            placeholder="Selecione"
            item-value="descricao"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" :cols="formData.tipo_consulta=='lotes'?1:2" v-if="exibirNivelGuia && formData.tipo_consulta!='lotes'">
          <label>Nº da Guia</label>
          <v-autocomplete
            v-model="formData.recurso_guia_id"
            :items="numGuiasList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Protocolo faturado</label>
          <v-autocomplete
            v-model="formData.protocolo"
            :items="protocolosFaturadosList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Protocolo demonstrado</label>
          <v-autocomplete
            v-model="formData.protocolo_demonstrado"
            :items="protocolosDemonstradosList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Protocolo envio</label>
          <v-autocomplete
            v-model="formData.protocolo_envio"
            :items="protocolosEnvioRecursoList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" cols="2">
          <label>Data envio</label>
          <v-autocomplete
            v-model="formData.data_envio"
            :items="datasEnvioRecursoList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 py-0" cols="1"  v-if="exibirNivelGuia && formData.tipo_consulta!='lotes'">
          <label>Beneficiário</label>
          <v-autocomplete
            v-model="formData.carteira_beneficiario"
            :items="beneficiariosList"
            placeholder="Selecione"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col class="px-2 pt-5 align-right">
          <v-btn
            style="margin-right: 16px !important"
            small
            height="32px"
            color="primary"
            class="px-2 mr-2"
            depressed
            @click="filterList(formData)"
            >Filtrar</v-btn>
          <v-btn
            outlined
            small
            height="32px"
            color="primary"
            class="px-2 ml-0"
            depressed
            @click="clearFilter()"
            >Limpar Filtro</v-btn
          >
        </v-col>
      </v-row>
      <v-row class="py-2 pl-2 pr-2">
        <v-spacer/>
          <v-btn v-if="formData.tipo_consulta == 'lotes' && envio_manual && (tipo_protocolo == null || tipo_protocolo == 'pagamento')" class="mt-5" color="primary" text @click="showProtocoloEnvioRecursoDlg=true">
              <v-icon small class="pr-2">fa-pencil-alt</v-icon>
              Protocolo único
          </v-btn>
           <!--  v-if="tipo_consulta=='lote'" -->
          <v-btn class="mt-5" color="primary" text @click="downloadDocument()">
              <v-icon small class="pr-2">fa-download</v-icon>
              Exportar tabela 
          </v-btn>
      </v-row>
    </v-form>
    <ProtocoloEnvioRecursoDlg
      :close="()=>showProtocoloEnvioRecursoDlg=false"
      :dialog="showProtocoloEnvioRecursoDlg"
      :grupoEconomico="grupoEconomico"
      :info="dadosPagamento"
      :protocolo_pagamento="protocolo_pagamento"
      :updatePage="()=>filterList(formData)"
    />
  </v-main>
</template>

<script>
import { mapState } from "vuex";
import ProtocoloEnvioRecursoDlg from '@/components/recebiveis/acompanhamento_de_envio/ProtocoloDlg'
const initialFormData = {
  tipo_consulta: "lotes",
  status_envio: null,
  numero_lote: null,
  recursadas: false,
  recurso_guia_id: null,
  protocolo: null,
  protocolo_envio: null,
  protocolo_demonstrado: null,
  identificador_prestador: null
};
export default {
  components:{
    ProtocoloEnvioRecursoDlg
  },
  data() {
    return {
      comboEstados:[],
      formData: { ...initialFormData },
      identOperadoraList: [],
      showProtocoloEnvioRecursoDlg: false,
      envio_digitacao_robo: null
    };
  },
  watch: {
    filterData: {
      deep: true,
      handler(val) {
        this.formData = Object.assign({}, initialFormData, val);
        if(this.formData.numero_lote=="Selecione")
          this.formData.numero_lote = null
      },
    },
    ident_operadora:{
      deep: true,
      handler(val) {
        this.identOperadoraList = val.map(el=> ({id:el.identificador_prestador, descricao:el.identificador_prestador}))
        this.identOperadoraList.unshift({ id: null,  descricao: "Selecione"})
      }
    },
    parametrizacao:{
      deep: true,
      handler() {
        let ind = this.comboEstados.findIndex(el => el.id == 4)
        if(this.parametrizacao.RG_ENVIORECURSO_DIGITACAO){
          this.envio_digitacao_robo = true
          if(ind == -1)
            this.comboEstados.splice(3, 0, { id: 4, descricao: 'Transmissão parcial', color: '#4A4A4A'});
        } else {
          this.envio_digitacao_robo = false
          this.formData.tipo_consulta = 'lotes'
          if(ind > -1)
            this.comboEstados.splice(ind, 1)
        }
      }
    }
  },
  mounted() {
    let filtroExterno = null
    let tipo_consulta = this.formData.tipo_consulta
    this.comboEstados = this.estadoList
    //this.comboEstados[this.comboEstados.findIndex(el => el.descricao == 'Acatado')].id = 42
  
    this.$store.dispatch("recebiveis/getFilter", 'acompanhamentoDeEnvioFilter',  { root: true }).then(resp => { 
      filtroExterno = resp
        if(filtroExterno){
          this.formData.identificador_prestador = filtroExterno.ident_prest
        }
        this.formData.tipo_consulta = tipo_consulta
        if(this.formData.numero_lote=="Selecione")
          this.formData.numero_lote = null

        this.filterList(this.formData);
        
    })
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      formRules : (state) => state.formRules,
    }),
  },
  methods: {
    downloadDocument() {
      let acao = this.formData.tipo_consulta=="lotes"? "getcsvlotesrecursados":"getcsvitensrecursados";
      let Payload = {
        grupo_economico: this.grupoEconomico,
        pagamento_id: this.dadosPagamento.id,
        envioRoboDigi: this.parametrizacao.RG_ENVIORECURSO_DIGITACAO,
        ...this.filterData
      };
      this.$store
        .dispatch(
          "documents/getDocumentPost",
          { Payload, acao },
          { root: true }
        ).then(()=> {
          alert()
        })
    },
    clearFilter() {
      let tipo_consulta = this.formData.tipo_consulta
      this.formData = { ...initialFormData, tipo_consulta}
      this.filterList(this.formData)
    },
    selectList() {
      this.clearFilter();
    },
  },
  props: {
    dadosPagamento: Object,
    envio_manual: Boolean,
    estadoList: Array,
    exibirNivelGuia: Boolean,
    filterData: Object,
    filterList: Function,
    ident_operadora: Array,
    lotes_pagamento: Array,
    openModal: Function,
    protocolo_pagamento: Object,
    tipo_protocolo: String,
    parametrizacao: Object,
    numLotesList: Array,
    numGuiasList: Array,
    protocolosFaturadosList: Array,
    protocolosDemonstradosList: Array,
    protocolosEnvioRecursoList: Array,
    datasEnvioRecursoList: Array,
    beneficiariosList: Array
  },
};
</script>